import { render, staticRenderFns } from "./MySettingsModal.vue?vue&type=template&id=cf2a06fa&"
import script from "./MySettingsModal.vue?vue&type=script&lang=js&"
export * from "./MySettingsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports